import { ReactElement } from "react";

import Container from "hardcover-ui/components/Container";
import LetterbooksViewType from "types/LetterbooksViewType";

export interface PageProps {
  children: ReactElement;
  view: LetterbooksViewType;
}

export default function DynamicListContainer({ view, children }: PageProps) {
  return (
    <Container
      size={view === "table" ? "lg" : "sm"}
      variant="primary"
      className="md:bg-white/70 md:dark:bg-gray-800/80 backdrop-blur-xs backdrop-brightness-150 dark:backdrop-brightness-100 rounded-lg rounded-b-none min-h-[200px] transition-all duration-300 ease-in-out"
    >
      {children}
    </Container>
  );
}
